// Puts a module's API on window under the name .NET calls it by. The core script installed a stand-in there that
// forwards to whatever this assigns, so the assignment must replace it unconditionally.
export function publish(name: string, value: unknown): void {
    window[name] = value;
}
